import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'features.walletPage.pageTitle',
    defaultMessage: 'Portafoglio',
    description: 'Title of wallet page',
  },

  positionToggleLabel: {
    id: 'features.walletPage.positionToggleLabel',
    defaultMessage: 'Elenco posizioni',
    description: 'First toggle label',
  },

  performanceToggleLabel: {
    id: 'features.walletPage.secondToggleLabel',
    defaultMessage: 'Performance',
    description: 'Second toggle label',
  },

  detailsSectionLabel: {
    id: 'features.walletPage.detailsSectionLabel',
    defaultMessage: 'Vedi dettaglio',
    description: 'Label for details section',
  },

  showBalance: {
    id: 'features.walletPage.showBalance',
    defaultMessage: 'mostra saldo',
    description: 'Label for link to show balance',
  },
  blurBalance: {
    id: 'features.walletPage.blurBalance',
    defaultMessage: 'nascondi saldo',
    description: 'Label for link to blur balance',
  },
  filterWallet: {
    id: 'features.walletPage.filterWallet',
    defaultMessage: 'filtra il tuo portafoglio',
    description: 'Label for link to filter wallet',
  },

  openDetailLabel: {
    id: 'features.wallet.openDetailLabel',
    defaultMessage: 'Apri dettaglio',
    description: '',
  },

  emptyWallet: {
    id: 'features.wallet.emptyWallet',
    defaultMessage: 'Non sono presenti prodotti in portafoglio.',
    description: 'Empty wallet message',
  },

  /** tab labels/select labels */

  myWalletLabel: {
    id: 'features.walletPage.myWalletLabel',
    defaultMessage: 'Il mio portafoglio',
    description: '',
  },
  myWalletLabelShared: {
    id: 'features.walletPage.myWalletLabelShared',
    defaultMessage: 'Rapporti cointestati',
    description: '',
  },
  jointRelationshipsLabel: {
    id: 'features.walletPage.jointRelationshipsLabel',
    defaultMessage: 'Rapporti cointestati',
    description: '',
  },

  pirBoxLabel: {
    id: 'features.walletPage.pirBoxLabel',
    defaultMessage: 'PIR Box',
    description: '',
  },

  /** wallet card message */

  cardTitle: {
    id: 'features.walletPage.cardTitle',
    defaultMessage: 'Totale Portafoglio',
    description: 'Title of the wallet card',
  },

  gainLabel: {
    id: 'features.walletPage.gainLabel',
    defaultMessage: 'Rendimento',
    description: 'Gain of the wallet card',
  },

  /** underlying common table columns */
  detailUnderlyingAmount: {
    id: 'features.wallet.detailUnderlyingAmount',
    defaultMessage: 'Quantità',
    description: 'Label for the amount column in the underlying table',
  },
  detailUnderlyingMediumPrice: {
    id: 'features.wallet.detailUnderlyingMediumPrice',
    defaultMessage: 'Prezzo medio di carico',
    description: 'Label for the medium price column in the underlying table',
  },
  detailUnderlyingMarketPrice: {
    id: 'features.wallet.detailUnderlyingMarketPrice',
    defaultMessage: 'Prezzo di mercato',
    description: 'Label for the market price column in the underlying table',
  },
  detailUnderlyingCountervalue: {
    id: 'features.wallet.detailUnderlyingCountervalue',
    defaultMessage: 'Controvalore',
    description:
      'Label for the countervalue column in the detail underlying table',
  },

  /** underlying managed funds table columns */
  detailUnderlyingMFProduct: {
    id: 'features.wallet.detailUnderlyingMFProduct',
    defaultMessage: 'Prodotto',
    description:
      'Label for the product column in the underlying managed funds table',
  },
  detailUnderlyingMFMediumChange: {
    id: 'features.wallet.detailUnderlyingMFMediumChange',
    defaultMessage: 'Cambio medio di carico',
    description:
      'Label for the medium change column in the underlying managed funds table',
  },
  detailUnderlyingMFRate: {
    id: 'features.wallet.detailUnderlyingMFRate',
    defaultMessage: 'Rateo',
    description:
      'Label for the rate column in the underlying managed funds table',
  },
  detailUnderlyingMFPercentageIncrease: {
    id: 'features.wallet.detailUnderlyingMFPercentageIncrease',
    defaultMessage: '% Inc',
    description:
      'Label for the percentage increase column in the underlying managed funds table',
  },
  detailUnderlyingMFPercentageRiskCoefficient: {
    id: 'features.wallet.detailUnderlyingMFPercentageRiskCoefficient',
    defaultMessage: '% Coeff. rischio',
    description:
      'Label for the percentage risk coefficient column in the underlying managed funds table',
  },

  /** underlying unit linked table columns */
  detailUnderlyingULPercentage: {
    id: 'features.wallet.detailUnderlyingULPercentage',
    defaultMessage: 'Percentuale',
    description:
      'Label for the percentage column in the underlying unit linked table',
  },
  detailUnderlyingULMarketPriceDate: {
    id: 'features.wallet.detailUnderlyingULMarketPriceDate',
    defaultMessage: 'Data prezzo di mercato',
    description:
      'Label for the market price date in the underlying unit linked table',
  },
  previnetLinkLabel: {
    id: 'features.wallet.previnetLinkLabel',
    defaultMessage: 'I tuoi fondi pensione',
    description: 'Label for previnet link',
  },
  previnetLinkMouseOverLabel: {
    id: 'features.wallet.previnetLinkMouseOverLabel',
    defaultMessage:
      'cliccando sul link, è possibile consultare i tuoi prodotti in ambito di previdenza',
    description: 'Label for mouse over previnet link',
  },
  previnetLinkMobileLabel: {
    id: 'features.wallet.previnetLinkMobileLabel',
    defaultMessage: 'Fondi pensione',
    description: 'Label for previnet link mobile',
  },
  sustainableFutureLinkLabel: {
    id: 'features.wallet.sustainableFutureLinkLabel',
    defaultMessage: 'Sustainable future',
    description: 'Label for sustainable future link',
  },
  sustainableFutureLinkMouseOverLabel: {
    id: 'features.wallet.sustainableFutureLinkMouseOverLabel',
    defaultMessage:
      'cliccando sul link, è possibile consultare i tuoi prodotti Sustainable future',
    description: 'Label for mouse over sustainable future link',
  },

  errorDescriptionAccessPrevinet: {
    id: 'features.wallet.errorDescriptionAccessPrevinet',
    defaultMessage:
      'Non è stato possibile accedere alla sezione dedicata ai Fondi Pensione. Si prega di riprovare.',
    description: 'Description of error to access previnet',
  },

  /** wallet widget home */

  walletWidgetSubtitleLabel: {
    id: 'features.wallet.subtitleLabel',
    defaultMessage: 'Totale Portafoglio',
    description: 'Subtitle of the wallet widget in the home page',
  },
  walletWidgetLinkGoToWallet: {
    id: 'features.wallet.walletWidgetLinkGoToWallet',
    defaultMessage: 'vai al portafoglio',
  },

  /** wallet detail positions list */

  walletDetailPositionsListLabel: {
    id: 'features.wallet.walletDetailPositionsListLabel',
    defaultMessage: 'Dettaglio elenco posizioni',
  },

  /** wallet performance detail */

  walletPerformanceDetail: {
    id: 'features.wallet.walletPerformanceDetail',
    defaultMessage: 'Dettaglio performance',
    description: 'Title of the performance detail page',
  },
  walletTransactionsDetailTitle: {
    id: 'features.wallet.walletTransactionsDetailTitle',
    defaultMessage: 'Dettaglio movimenti',
    description: 'Title of the transactions detail page',
  },
  walletUnderlyingDetailTitle: {
    id: 'features.wallet.walletUnderlyingDetailTitle',
    defaultMessage: 'Dettaglio sottostanti',
    description: 'Title of the underlying detail page',
  },
  walletPaymentNotValidated: {
    id: 'features.wallet.walletPaymentNotValidated',
    defaultMessage: 'Versamenti non ancora avvalorati FIA',
    description: 'Versamenti non ancora avvalorati FIA',
  },
  walletTotalAmount: {
    id: 'features.wallet.walletTotalAmount',
    defaultMessage: 'Totale complessivo portafoglio',
    description: 'Totale complessivo portafoglio',
  },
  walletTotalModal: {
    id: 'features.wallet.walletTotalModal',
    defaultMessage:
      'L’importo rappresentato considera anche i versamenti effettuati dal cliente a mezzo bonifico per i FIA non ancora avvalorati in quanto sono in corso le attività di verifica da parte della Banca Depositaria oppure - per i fondi multi-richiamo - si è in attesa del calcolo del nuovo NAV relativo al richiamo oggetto di versamento. Per questo motivo, tali importi non possono ancora essere considerati nel calcolo delle performance.',
    description: 'Modal Economia Reale',
  },
  walletBackTextModal: {
    id: 'features.wallet.walletBackTextModal',
    defaultMessage: 'Indietro',
    description: 'Modal back text',
  },
  walletAlternativePirBox: {
    id: 'features.wallet.walletAlternativePirBox',
    defaultMessage: 'Deposito PIR Alternative Sottoscritto',
    description: 'Deposito PIR Alternative Sottoscritto',
  },
  walletOrdinaryPirBox: {
    id: 'features.wallet.walletOrdinaryPirBox',
    defaultMessage: 'Deposito PIR Ordinario Sottoscritto',
    description: 'Deposito PIR Ordinario Sottoscritto',
  },
  walletAlternativePirBoxPositionList: {
    id: 'features.wallet.walletAlternativePirBoxPositionList',
    defaultMessage:
      '* Prodotto sottoscritto all’interno di un deposito PIR Alternative',
    description:
      'Disclaimer showed in the position list located in wallet page',
  },
  walletTotalFiaNote: {
    id: 'features.wallet.walletTotalFiaNote',
    defaultMessage:
      '*** La cifra rappresentata comprende anche i versamenti a favore di FIA non ancora valorizzati al NAV (valore quota del fondo), in quanto sono in corso le attività di verifica da parte della Banca Depositaria oppure - per i fondi multi-richiamo - si è in attesa del calcolo del nuovo NAV relativo al richiamo oggetto di versamento. Per questo motivo, tali importi non possono ancora essere considerati nel calcolo delle performance.',
    description:
      'Disclaimer showed in the position list located in wallet page',
  },
  walletOrdinaryPirBoxPositionList: {
    id: 'features.wallet.walletAlternativePirBoxPositionList',
    defaultMessage:
      '* Prodotto sottoscritto all’interno di un deposito PIR Ordinario',
    description:
      'Disclaimer showed in the position list located in wallet page',
  },
  viewDetails: {
    id: 'features.wallet.viewDetails',
    defaultMessage: 'VEDI DETTAGLIO',
    description: 'Button text in real economy',
  },
});
